import SectionTitle from '@/ui/SectionTitle/SectionTitle';
import { Fire } from '@/icons/section';
import SliderWrapper from '@/ui/SliderWrapper/SliderWrapper';
import { TariffCard } from '@/ui/index';

const HotOffers = ({ items }) => {
  const renderSlider = (tariff, index) => {
    return <TariffCard key={`${index}_tariff`} item={tariff} />;
  };

  return (
    <div
      className={'section'}
      data-testid='hot-offers'
      itemScope
      itemType='https://schema.org/Offer'
    >
      <SectionTitle
        Icon={Fire}
        className={'wrapper'}
        titleModify='title--large'
      >
        {items?.image || null}
      </SectionTitle>
      <SliderWrapper arrows>{items?.tariffs?.map(renderSlider)}</SliderWrapper>
    </div>
  );
};

export default HotOffers;
